import { ClinicalSummaryLinkControllerApi } from "../../services";
import { ClinicalSummaryLinkRequest } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author [Atish Bagate]
 */
export const useClinicalSummaryLink = () =>
  useMutationWithLoading(
    async (params: {
      clinicalSummaryLinkRequest: ClinicalSummaryLinkRequest;
      xTENANTID?: string;
    }) =>
      new ClinicalSummaryLinkControllerApi(
        getConfigObject()
      ).linkClinicalDataToAppointment(
        params.clinicalSummaryLinkRequest,
        params.xTENANTID
      )
  );
